/** @format */

import React, { FC, useState, useMemo } from 'react'
import { _$, Card, Select, Option } from '@king-design/react'
import { useAsync } from 'react-use'
import styled from 'styled-components'
import useNavRegion from 'src/hooks/useNavRegion'
import { MonitorCrumb } from 'src/components'
import { getGrafanaInstanceList } from 'src/api/ApiGrafana'
import { getPromethuesInstance } from 'src/api/ApiPromethuesInstance'
import useTableGroup from 'src/hooks/useTableGroup'
import { useHistory } from 'react-router'

const MetricExplore: FC<any> = ({ className }) => {
  const history = useHistory()
  const [prometheusInstance, setPrometheusInstance] = useState<any>({})
  // 控制台region
  const region = useNavRegion()
  // regionlist
  const regionGroup = useTableGroup('monitorRegionList')
  // 获取资源
  const { value: grafana_list, loading: grafana_loading } = useAsync(async () => {
    const result = await getGrafanaInstanceList()
    return result?.InstancesSet?.filter(item => item.InstanceStatus === 'running') || []
  }, [region])

  const { value: prometheus_list, loading: prometheus_loading } = useAsync(async () => {
    if (region) {
      const result = await getPromethuesInstance({
        SearchRegion: region
      })
      if (result?.InstancesSet?.length) {
        setPrometheusInstance(result?.InstancesSet[0])
      } else {
        setPrometheusInstance({})
      }
      return result?.InstancesSet || []
    } else {
      return []
    }
  }, [region])

  // region中文
  const regionName = useMemo(() => {
    return regionGroup?.find((item: any) => item.value === region)?.label
  }, [region, regionGroup])

  // url
  const grafanaUrl = useMemo(() => {
    if (grafana_list?.length && prometheusInstance?.Region) {
      const grafana = grafana_list?.[0]
      const left = {
        range: { from: 'now-12h', to: 'now' },
        queries: [
          {
            datasource: { type: 'prometheus', uid: `prom-${prometheusInstance.Region}` },
            instant: false,
            refId: 'A'
          }
        ]
      }
      return `${grafana?.AccessURL}/explore?kiosk=true&auth_token=${
        grafana?.AccessToken
      }&left=${JSON.stringify(left)}&exploreHideDatasource=true`
    }
    return ''
  }, [grafana_list, prometheusInstance])

  return (
    <div className={className}>
      <MonitorCrumb breadArr={[{ title: _$('Prometheus监控') }, { title: _$('指标探索') }]} />
      {!grafana_loading && !prometheus_loading ? (
        <Card>
          <div className="select_instance">
            <p>{_$('选择实例')}</p>
            <Select
              width={300}
              value={prometheusInstance.ClusterID || ''}
              filterable
              placeholder={_$('请选择实例')}
              onChangeValue={value => {
                const find = prometheus_list?.find(item => item.ClusterID === value)
                setPrometheusInstance(find || {})
              }}
            >
              {prometheus_list?.map((item: any) => (
                <Option key={item.ClusterID} value={item.ClusterID}>
                  {item.InstanceName}
                </Option>
              ))}
            </Select>
          </div>
          {/* 有prometheus实例并且开通了grafana服务 */}
          {prometheus_list?.length && prometheusInstance?.ClusterID && grafana_list?.length ? (
            <div className="iframe_box">
              <iframe
                title="Grafana Explore"
                // eslint-disable-next-line max-len
                src={grafanaUrl}
                width="100%"
                height="100%"
              ></iframe>
            </div>
          ) : null}

          {/* 没有prometheus实例 */}
          {!prometheus_list?.length ? (
            <div>
              <p className="tips_text">
                {_$('请先创建{name}下Prometheus实例。', { name: regionName })}
                <a
                  onClick={() => {
                    history.push('/monitor/prometheusmonitor/instanceinfo')
                  }}
                >
                  {_$('开通Prometheus实例')}
                </a>
              </p>
            </div>
          ) : null}
          {/* 没有开通grafana服务 */}
          {!grafana_list?.length ? (
            <div>
              <p className="tips_text">
                {_$('请先开通grafana服务。')}
                <a
                  onClick={() => {
                    history.push('/monitor/grafana/instancelist')
                  }}
                >
                  {_$('点击开通Grafana服务')}
                </a>
              </p>
            </div>
          ) : null}
        </Card>
      ) : null}
    </div>
  )
}

export default styled(MetricExplore)`
  .select_instance {
    display: flex;
    align-items: center;
    p {
      margin-right: 8px;
      margin-bottom: 0px;
    }
  }
  .iframe_box {
    margin-top: 16px;
    height: 100vh;
    iframe {
      border: 1px solid #e8e8e8;
    }
  }
  .tips_text {
    font-size: 14px;
    margin-top: 16px;
  }
`
